export default "__VITE_ASSET__ZHLFBT_1__"